var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"d-flex align-center",attrs:{"cols":"12"}},[_c('v-img',{attrs:{"src":require("@/assets/images/banner.jpg"),"alt":"Logo Inteligencia Objetiva","contain":"","max-height":"300"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }